import wlmScanPicture from './main';

export default {
  install(Vue) {
    Vue.component(wlmScanPicture.name, wlmScanPicture);
  },
};

